import productLabelApi from "~/api/product_label";

const fetchProductLabelById = async (context, productLabelId) => {
  if (context.state.fetchingProductLabelsIds.indexOf(productLabelId) !== -1
    || context.getters.hasProductLabelById(productLabelId)) {
    return Promise.resolve();
  }

  context.commit("SET_FETCHING_PRODUCT_LABEL_IDS", [productLabelId]);

  return productLabelApi.find(productLabelId)
    .then((response) => {
      context.commit("UNSET_FETCHING_PRODUCT_LABEL_IDS", [productLabelId]);
      context.commit("CACHE_PRODUCT_LABEL", response.data);

      return response.data;
    });
};

const fetchProductLabelsByIds = async (context, productLabelIds) => {
  const filteredProductLabelIds = productLabelIds
    .filter((productLabelId) => context
      .state.fetchingProductLabelsIds.indexOf(productLabelId) === -1)
    .filter((productLabelId) => !context.getters.hasProductLabelById(productLabelId));

  if (filteredProductLabelIds.length === 0) {
    return Promise.resolve();
  }

  context.commit("SET_FETCHING_PRODUCT_LABEL_IDS", filteredProductLabelIds);

  return productLabelApi.getProductLabelsByIds(filteredProductLabelIds)
    .then((response) => {
      context.commit("UNSET_FETCHING_PRODUCT_LABEL_IDS", filteredProductLabelIds);
      context.commit("CACHE_PRODUCT_LABELS", response.data);

      return response.data;
    });
};

export default {
  fetchProductLabelById,
  fetchProductLabelsByIds,
};
